<template>
  <div style="text-align: center">
    <h3 class="kaihu">账号开户</h3>
    <step :active="1"></step>
    <div v-if="type == 1">
      <img src="@/assets/rengongshenhezhong.png" />
      <br />
      <b>人工审核中</b>
      <div style="color:#B4CFFF;margin-top:48px;">
        您已完成开户信息输入，请您耐心等待平台人工审核。
        <br />
        审核通过后，平台将提交您的信息至银行进行电子账户开户审核。
      </div>
      <el-button type="primary" @click="backToHome" style="margin-top:74px;">
        返回首页
      </el-button>
    </div>
    <div v-else-if="type == 2">
      <img src="@/assets/zhifushenheshibai.png" />
      <br />
      <b>人工审核失败</b>
      <div style="color:#B4CFFF;margin-top:48px;">
        您的开户信息填写有误，请您重新进行填写
        <br />
        审核失败原因：{{ reason }}
      </div>
      <el-button type="primary" @click="toStep1" style="margin-top:74px;">
        重新输入
      </el-button>
    </div>
    <div v-else>
      <img src="@/assets/zhifuchenggong.png" />
      <br />
      <b>人工审核成功</b>
      <div style="color:#B4CFFF;margin-top:48px;">
        您已完成人工审核，请您耐心等待银行审核。
      </div>
      <el-button type="primary" @click="backToHome" style="margin-top:74px;">
        返回首页
      </el-button>
    </div>
  </div>
</template>
<script>
import step from './step.vue';
export default {
  props: {
    reason: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 1 //1是审核中 2是失败 3是成功
    }
  },
  data() {
    return {};
  },
  components: {
    step
  },
  methods: {
    backToHome() {
      this.$router.push({
        name: 'home'
      });
    },
    toStep1() {
      this.$parent.currentCom = 'step1';
    }
  }
};
</script>
<style lang="scss" scoped></style>
